import React from 'react';
import Icon from '@ant-design/icons';
import { Button as AntdButton } from 'antd';
import NoDataSvg from './noData.svg';

export const NoDataIcon = props => <Icon component={NoDataSvg} {...props} />;

export const NoDataIconButton = props => {
  return (
    <AntdButton
      {...props}
      type="text"
      icon={<NoDataIcon />}
    />
  );
};
